import axios from 'axios'
import qs from 'qs'
import router from '@/router'
import i18n, { localPath } from '@/i18n'
import { getToken, removeToken } from '@/utils/auth.js'
import { ElMessageBox, ElMessage } from 'element-plus'

// axios.defaults.baseURL = process.env.VUE_APP_BASE_API
const instance = axios.create({
  baseURL: window.global_config.ip,
})

// request 拦截器
instance.interceptors.request.use((config) => {
  // 非登录请求添加请求头
  if (config.url !== '/auth/login') {
    config.headers.Authorization = `Bearer ${getToken()}`
  }
  // get 请求数组转化为 id=1&id=2&id=3 形式
  if (config.method === 'get') {
    config.paramsSerializer = (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    }
  }
  return config
})
window.time = null
// response 拦截器
instance.interceptors.response.use(
  (config) => {
    const data = config.request.responseURL
    if (data.includes('/manga/user/download') || data.includes('/manga/user/batchDownload')){
      return config;
    }
    if (config.data && config.data.code !== 200) {
      ElMessage.error(config.data.message || '请求失败')
      return Promise.reject(new Error('error'))
    }
    return config
  },
  async (error) => {
    // 检查是否有响应对象
    if (error.response) {
      // 暂时设置排除的开放页面
      if (error.response.status === 401) {
        if (!getToken()) {
          return Promise.reject(error)
        }
        try {
          if (window.time) {
            clearTimeout(window.time)
          }
          window.time = setTimeout(async () => {
            const t = i18n.global.t
            const confirmResult = await ElMessageBox.confirm(error.response.data.message, t('translate.systemPrompt'), {
              cancelButtonText: t('translate.cancel'),
              confirmButtonText: t('translate.reLogin'),
              type: 'warning',
            })
            if (confirmResult === 'confirm') {
              removeToken()
              router.push(localPath('/login'))
            }
          }, 500)
        } catch (e) {
          removeToken()
        }
      } else if (error.response.status === 403) {
        ElMessage.error(error.response.data.message)
      } else {
        ElMessage.error(error.response.statusText || `${i18n.global.t('translate.httpError')}: ${error.response.status}`)
      }
    } else {
      // 网络错误或其他错误
      ElMessage.error(error.message || '网络请求失败')
    }
    return Promise.reject(error)
  }
)

export default instance
